import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faAngleLeft,
    faHome,
    faNewspaper,
    faSeedling,
    faFireAlt,
    faI,
    faHeadphones,
    faUser,
    faSignOutAlt,
    faLanguage
} from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";

function Header() {
    const [showSidebar, setShowSidebar] = useState(false);
    const { getLanguage, switchLanguage, getTranslation } = useLanguage();
    const { currentUser, logout } = useAuth();

    return (
        <header className="font-raleway text-white bg-primary px-7 h-16 flex">
            <Link to="/" className="flex items-center">
                <img className="w-11 h-11 border-2 border-white rounded-full" src="/assets/ava_pinni.png" alt="pinni-logo"/>
            </Link>

            <button className="text-4xl ml-auto xl:hidden" onClick={() => setShowSidebar(true)}>
                <FontAwesomeIcon icon={faAngleLeft} />
            </button>

            <div className={`fixed z-50 top-0 left-0 w-full h-screen overflow-x-hidden flex transition-bg duration-500 ease-in-out ${showSidebar ? "pointer-events-auto bg-neutral-100/50" : "pointer-events-none bg-none"} xl:static xl:h-full xl:pointer-events-auto xl:overflow-visible xl:ml-4`}>
                <div className="grow xl:hidden" onClick={() => setShowSidebar(false)}></div>
                <ul className={`font-bold uppercase h-full bg-primary transition-transform duration-500 ease-in-out ${showSidebar ? "translate-x-0" : "translate-x-full"} xl:translate-x-0 xl:flex xl:w-full`}>
                    {
                        [
                            ["Trang chủ", "Home", faHome, "/"],
                            ["Bài viết", "Posts", faNewspaper, "/posts"],
                            ["Cơ bản", "Beginner", faSeedling, "/beginner"],
                            ["Nâng cao", "Advanced", faFireAlt, "/advanced"],
                            ["IELTS", "IELTS", faI, "/ielts"],
                            ["Nghe thực tế", "Authentic Listening", faHeadphones, "/listening"],
                        ].map(([vn, en, icon, path], index) => {
                            return <li key={index} className="hover:bg-secondary transition-colors duration-100 ease-in-out">
                                <Link className="px-3 py-2 w-56 flex items-center xl:w-fit xl:h-full xl:px-5" to={path} onClick={() => setShowSidebar(false)}>
                                    <FontAwesomeIcon className="text-lg xl:hidden" icon={icon}/>
                                    <span className="ml-auto block w-40 xl:w-fit">{getTranslation(vn, en)}</span>
                                </Link>
                            </li>
                        })
                    }
                    {
                        currentUser
                        ?
                        <>
                            <li className="mt-10 hover:bg-secondary transition-colors duration-100 ease-in-out xl:mt-0 xl:h-full xl:flex xl:items-center xl:ml-auto">
                                <Link to="/profile" className="px-3 py-2 w-56 flex items-center xl:w-fit xl:px-5" onClick={() => setShowSidebar(false)}>
                                    <FontAwesomeIcon className="text-lg xl:hidden" icon={faUser}/>
                                    <span className="ml-auto block w-40 truncate xl:w-fit">{currentUser.displayName ? currentUser.displayName : currentUser.email}</span>
                                </Link>
                            </li>
                            <li className="mt-auto hover:bg-secondary transition-colors duration-100 ease-in-out xl:h-full xl:flex xl:items-center">
                                <button className="font-bold uppercase px-3 py-2 w-56 text-left flex items-center xl:w-fit" onClick={() => {setShowSidebar(false); logout()}}>
                                    <FontAwesomeIcon className="text-lg xl:hidden" icon={faSignOutAlt}/>
                                    <span className="ml-auto block w-40 xl:w-fit">{getTranslation("Đăng xuất", "Sign out")}</span>
                                </button>
                            </li>
                        </>
                        :
                        <li className="mt-10 xl:mt-0 xl:h-full xl:ml-auto">
                            <ul className="xl:flex xl:h-full xl:items-center">
                                {
                                    [
                                        ["Đăng nhập", "Sign in", "/login"],
                                        ["Đăng kí", "Sign up", "/signup"]
                                    ].map(([vn, en, path], index) => {
                                        return <li key={index} className="hover:bg-secondary transition-colors duration-100 ease-in-out xl:h-full xl:flex xl:items-center">
                                            <Link to={path} className="block px-3 py-2 w-56 xl:w-fit xl:px-5" onClick={() => setShowSidebar(false)}>
                                                {getTranslation(vn, en)}
                                            </Link>
                                        </li>
                                    })
                                }
                            </ul>
                        </li>
                    }
                    <li className="px-3 py-2 flex items-center">
                        <FontAwesomeIcon icon={faLanguage} className="text-lg xl:hidden"/>
                        <p className="w-40 ml-auto xl:w-fit">
                            <span className={`cursor-pointer ${getLanguage() === "vie" ? "font-bold" : "font-normal"}`} onClick={() => switchLanguage("vie")}>VN</span> <span className="font-extralight">|</span> <span  className={`cursor-pointer ${getLanguage() === "eng" ? "font-bold" : "font-normal"}`} onClick={() => switchLanguage("eng")}>EN</span>
                        </p>
                    </li>
                </ul>
            </div>
        </header>
    )
}

export default Header;